/* eslint-disable no-new */
import { SignInModalToggleClass } from "./sign-in-modal-toggle-class";
import { SignInModalFormRequestClass } from "./sign-in-modal-form-request-class";
import SignInModalClass from "./sign-in-modal-class";

export default uuid => {
  const modalElement = document.querySelector(".js-sign-in-modal");
  if (!modalElement) return null;

  if (uuid) {
    modalElement.setAttribute("data-design-project-uuid", uuid);
    const signInForm = modalElement.querySelector(".js-sign-in-modal-form-in");
    if (signInForm) {
      signInForm.setAttribute("data-redirect-url", `/design-lab/${uuid}?show-save-project=true`);
    }
  }

  const signInFormRequest = new SignInModalFormRequestClass({
    formSelector: ".js-sign-in-modal-form-in",
    errorSelector: ".js-sign-in-modal-alert-error-in",
    mixpanelName: "customer_logged_in",
    uuid
  });
  signInFormRequest.init();

  const signUpFormRequest = new SignInModalFormRequestClass({
    formSelector: ".js-sign-in-modal-form-up",
    errorSelector: ".js-sign-in-modal-alert-error-up",
    mixpanelName: "account_created",
    uuid
  });

  signUpFormRequest.init();

  const signInModal = new SignInModalClass({
    modalSelector: ".js-sign-in-modal"
  });

  new SignInModalToggleClass({
    eventSelector: ".js-sign-in-modal-toggle",
    eventCallback: () => {
      signInFormRequest.hideErrors();
      signInFormRequest.hideRecaptcha();
      signUpFormRequest.hideErrors();
      signInModal.openModal();
    }
  });

  return signInModal;
};
